import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorStateMatcher } from '@angular/material/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TotenService} from '../services/toten.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-toten',
  templateUrl: './toten.component.html',
  styleUrls: [ './toten.component.scss' ]
})
export class TotenComponent implements OnInit {

  public searchForm: FormGroup;

  public dataSourceAllMembers: MatTableDataSource<any>
  public displayedColumnsAllMembers: string[] = [ 'name', 'cpf' ];

  public matcher = new FormErrorStateMatcher();

  public lines: any[] = []

  public numDoc: string;

  constructor (
    public router: Router,
    private route: ActivatedRoute,
    public _totenService: TotenService,
    private _formBuilder: FormBuilder
  ) {

    if (this.route.snapshot.paramMap.get('doc') != '""') {
      this.numDoc = this.route.snapshot.paramMap.get('doc');
    }

    this.searchForm = this._formBuilder.group({
      cpf: new FormControl(this.numDoc)
    });

  }

  ngOnInit () {
  }

  applyFilter (filterValue: string) {
    this.dataSourceAllMembers.filter = filterValue.trim().toLowerCase();
  }

  /*
  getUserSubscription51 () {

    // console.log("getUserSubscription51")

    if (this.searchForm.valid) {
      this._totenService.spinner = true

      const doc = this.searchForm.controls.cpf.value
      this._totenService.getUserSubscription(doc)
        .subscribe((result) => {

          console.log("doc: " + JSON.stringify(doc))
          console.log("result: " + JSON.stringify(result))

          if (result.subscription.status == "ok") {
            this.lines = result.subscription.lines
          } else {
             this.lines = [];
             this.lines[0] = "Não Encontrado"
          }
          this._totenService.spinner = false
        })
    }

  }
    */

  getUserSubscription () {

    // console.log("getUserSubscription")

    if (this.searchForm.valid) {
      this._totenService.spinner = true

      const doc = this.searchForm.controls.cpf.value
      this._totenService.getUserSubscriptionBJCVS(doc)
        .subscribe((result) => {

          console.log("doc: " + JSON.stringify(doc))
          console.log("result: " + JSON.stringify(result))

          if (result.subscription.status == "ok") {
            this.lines = result.subscription.lines
          } else {
             this.lines = [];
             this.lines[0] = "Não Encontrado"
          }
          this._totenService.spinner = false
        })
    }

  }

}
